import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: "#",
    class: "tw-flex tw-items-center tw-gap-2.5 tw-px-[18px] tw-py-3 tw-h-full !tw-no-underline tw-rounded-[100px] tw-text-center tw-text-[#387DFF] tw-text-center tw-text-[15px] tw-not-italic tw-font-medium tw-leading-[100%] tw-font-[Poppins] tw-border-2 tw-border-solid tw-border-[#387DFF] button",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('click')), ["prevent"]))
  }, _toDisplayString(_ctx.title), 1))
}